import {COUNTRIES, INDUSTRIES} from 'constants/index';
import moment from 'moment';

class CompanyHelper {
  static getIndustries() {
    return Object.keys(INDUSTRIES).map((key) => {
      return {
        key: key,
        value: key,
        label: INDUSTRIES[key],
      };
    });
  }

  static getEmployeeSize() {
    return [
      {
        key: '1',
        value: '1_20',
        label: '1-20 employees',
        // query: {
        //   [`${fieldName}[gte]`]: 1,
        //   [`${fieldName}[lte]`]: 10,
        // },
      },
      {
        key: '21',
        value: '21_50',
        label: '21-50 employees',
        // query: {
        //   [`${fieldName}[gte]`]: 11,
        //   [`${fieldName}[lte]`]: 50,
        // },
      },
      {
        key: '51',
        value: '51_100',
        label: '51-100 employees',
        // query: {
        //   [`${fieldName}[gte]`]: 51,
        //   [`${fieldName}[lte]`]: 200,
        // },
      },
      {
        key: '101',
        value: '101_250',
        label: '101-250 employees',
        // query: {
        //   [`${fieldName}[gte]`]: 201,
        //   [`${fieldName}[lte]`]: 500,
        // },
      },
      {
        key: '251',
        value: '251_500',
        label: '251-500 employees',
        // query: {
        //   [`${fieldName}[gte]`]: 501,
        //   [`${fieldName}[lte]`]: 1000,
        // },
      },
      {
        key: '501',
        value: '501_1000',
        label: '501-1000 employees',
        // query: {
        //   [`${fieldName}[gte]`]: 1001,
        //   [`${fieldName}[lte]`]: 5000,
        // },
      },
      {
        key: '1001',
        value: '1001_and_more',
        label: '1001+ employees',
        // query: {
        //   [`${fieldName}[gte]`]: 5001,
        //   [`${fieldName}[lte]`]: 10000,
        // },
      },
    ];
  }

  // static getEmployeeSize() {
  //   return [
  //     {
  //       key: '10',
  //       value: '1_20',
  //       label: '1-20 employees',
  //     },
  //     {
  //       key: '50',
  //       value: '21_50',
  //       label: '11-50 employees',
  //     },
  //     {
  //       key: '100',
  //       value: '51_100',
  //       label: '51-100 employees',
  //     },
  //     {
  //       key: '250',
  //       value: '101_250',
  //       label: '101-250 employees',
  //     },
  //     {
  //       key: '500',
  //       value: '251_500',
  //       label: '251-500 employees',
  //     },
  //     {
  //       key: '500',
  //       value: '501_1000',
  //       label: '501-1.000 employees',
  //     },
  //     {
  //       key: '1000',
  //       value: 'more_1000',
  //       label: '1.000+ employees',
  //     },
  //   ];
  // }

  static getDeployedResouces(fieldName = 'engaged_resources') {
    return [
      {
        key: '1-10',
        value: '1-10',
        label: '1-10 resources',
        query: {
          [`${fieldName}[gte]`]: 1,
          [`${fieldName}[lte]`]: 5,
        },
      },
      {
        key: '11-20',
        value: '11-20',
        label: '11-20 resources',
        query: {
          [`${fieldName}[gte]`]: 11,
          [`${fieldName}[lte]`]: 20,
        },
      },
      {
        key: '21-50',
        value: '21-50',
        label: '21-50 resources',
        query: {
          [`${fieldName}[gte]`]: 21,
          [`${fieldName}[lte]`]: 50,
        },
      },
      {
        key: '50+',
        value: '50+',
        label: '50+ resources',
        query: {
          [`${fieldName}[gte]`]: 51,
        },
      },
    ];
  }

  static getOpenRequisition(fieldName = 'open_requisitions') {
    return [
      {
        key: '1-10',
        value: '1-10',
        label: '1-10 requisitions',
        query: {
          [`${fieldName}[gte]`]: 1,
          [`${fieldName}[lte]`]: 5,
        },
      },
      {
        key: '11-20',
        value: '11-20',
        label: '11-20 requisitions',
        query: {
          [`${fieldName}[gte]`]: 11,
          [`${fieldName}[lte]`]: 20,
        },
      },
      {
        key: '21-50',
        value: '21-50',
        label: '21-50 requisitions',
        query: {
          [`${fieldName}[gte]`]: 21,
          [`${fieldName}[lte]`]: 50,
        },
      },
      {
        key: '50+',
        value: '50+',
        label: '50+ requisitions',
        query: {
          [`${fieldName}[gte]`]: 51,
        },
      },
    ];
  }

  static completedEngagements(
    label = 'engagements',
    prefix = '',
    name = 'completed_engagements',
  ) {
    return [
      {
        key: '1-5',
        value: '1-5',
        label: `${prefix}1-5 ${label}`,
        query: {
          [`${name}[gte]`]: 1,
          [`${name}[lte]`]: 5,
        },
      },
      {
        key: '6-10',
        value: '6-10',
        label: `${prefix}6-10 ${label}`,
        query: {
          [`${name}[gte]`]: 6,
          [`${name}[lte]`]: 10,
        },
      },
      {
        key: '11-20',
        value: '11-20',
        label: `${prefix}11-20 ${label}`,
        query: {
          [`${name}[gte]`]: 11,
          [`${name}[lte]`]: 20,
        },
      },
      {
        key: '21-50',
        value: '21-50',
        label: `${prefix}21-50 ${label}`,
        query: {
          [`${name}[gte]`]: 21,
          [`${name}[lte]`]: 50,
        },
      },
      {
        key: '51-100',
        value: '51-100',
        label: `${prefix}51-100 ${label}`,
        query: {
          [`${name}[gte]`]: 51,
          [`${name}[lte]`]: 100,
        },
      },
      {
        key: '100+',
        value: '100+',
        label: `${prefix}100+ ${label}`,
        query: {
          [`${name}[gt]`]: 100,
        },
      },
    ];
  }

  static getMembershipDuration(name = 'created_at') {
    return [
      {
        key: '3M',
        value: '3M',
        label: 'At least 3 months',
        query: {
          [`${name}[lte]`]: moment().subtract(3, 'months').unix(),
        },
      },
      {
        key: '6M',
        value: '6M',
        label: 'At least 6 months',
        query: {
          [`${name}[lte]`]: moment().subtract(6, 'months').unix(),
        },
      },
      {
        key: '1Y',
        value: '1Y',
        label: 'At least 1 year',
        query: {
          [`${name}[lte]`]: moment().subtract(1, 'year').unix(),
        },
      },
      {
        key: '3Y',
        value: '3Y',
        label: 'At least 3 years',
        query: {
          [`${name}[lte]`]: moment().subtract(3, 'years').unix(),
        },
      },
    ];
  }

  static getCountries() {
    return Object.keys(COUNTRIES).map((key) => {
      return {
        key: key,
        value: key,
        label: COUNTRIES[key],
      };
    });
  }

  static getPerformanceRating(fieldName = 'rating_total') {
    return [
      {
        key: '1+',
        value: '1+',
        label: '1+ Stars',
        query: {
          [`${fieldName}[gte]`]: 1,
        },
      },
      {
        key: '2+',
        value: '2+',
        label: '2+ Stars',
        query: {
          [`${fieldName}[gte]`]: 2,
        },
      },
      {
        key: '3+',
        value: '3+',
        label: '3+ Stars',
        query: {
          [`${fieldName}[gte]`]: 3,
        },
      },
      {
        key: '4+',
        value: '4+',
        label: '4+ Stars',
        query: {
          [`${fieldName}[gt]`]: 4,
        },
      },
    ];
  }
}

export default CompanyHelper;
